import { type UserLevel } from '@common/types/api/auth';
import {
  type DataHistoryAggregation,
  type DataHistoryResolution,
  type Unit,
} from '@common/types/api/register';

export interface ChartRange {
  startDate: Date;
  endDate: Date;
}

export interface OfflinePeriod {
  startingTime: Date;
  endingTime: Date;
}

export interface OfflineHistory {
  points: OfflinePeriod[];
}

export enum GraphProfileContextType {
  Diagram = 10,
  Statistics = 20,
}

export enum GraphItemVisualisationType {
  Line = 10,
  Bar = 20,
  Area = 30,
  SeparateTimeline = 40,
  Stepline = 50,
}

export enum GraphItemContextType {
  DataPoints = 10,
  Parameters = 20,
}

export interface ResolutionUnit {
  resolution: DataHistoryResolution;
  unit: Unit;
}

export interface GraphProfilesResponseGraphItem {
  registerSpecificationId: number;
  registerSpecificationGroupId: number;
  registerName: string;
  registerIndex: number;
  flag?: number;
  graphItemContextType: GraphItemContextType;
  graphItemVisualisationType?: GraphItemVisualisationType;
  resolutionUnits?: ResolutionUnit[];
  aggregationMethod?: DataHistoryAggregation;
}

export interface GraphProfilesResponseGraph {
  name?: string;
  graphItems: GraphProfilesResponseGraphItem[];
}

export interface GraphProfilesResponse {
  id: string;
  isGlobal: boolean;
  accessLevelId: UserLevel;
  graphProfileContextType?: GraphProfileContextType;
  installationProfileId: number;
  name: string;
  graphs: GraphProfilesResponseGraph[];
}

export interface GraphProfileRequestGraphItem {
  registerSpecificationId: number;
  registerSpecificationGroupId: number;
  flag?: number;
  graphItemContextType: GraphItemContextType;
  graphItemVisualisationType: GraphItemVisualisationType;
  resolutionUnits?: ResolutionUnit[];
  aggregationMethod?: DataHistoryAggregation;
}

export interface GraphProfileRequestGraph {
  graphItems: GraphProfileRequestGraphItem[];
}

export interface GraphProfilesRequest {
  isGlobal: false;
  accessLevelId?: UserLevel;
  graphProfileContextType: GraphProfileContextType | undefined;
  installationProfileId: number;
  name: string;
  graphs: GraphProfileRequestGraph[];
}
